import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { RESULTS_TESTIMONIALS } from '../data/content';
export function ResultsTestimonials() {
  return <section className="w-full bg-sand py-20 sm:py-24" data-id="element-199" data-mp="1d1bgj06jb9qn">
      <div className="mx-auto max-w-6xl px-5" data-id="element-200" data-mp="1d0ry7icz2jc3">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-201" data-mp="18zg9df1xa24y">
          <p className="text-sm font-semibold uppercase tracking-widest text-clay" data-id="element-202" data-mp="1922obzr57jx7">
            Resultados reales
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-203" data-mp="gbkdudo3ag9r">
            Profes de Yoga ya están usando recursos de RecursosFitness™
          </h2>
        </Reveal>

        <div className="mt-12 columns-1 gap-6 sm:columns-2 lg:columns-3" data-id="element-204" data-mp="pbz3fp836hj2">
          {RESULTS_TESTIMONIALS.map((t, i) => <Reveal key={t.name + i} delay={i % 3 * 0.06} className="mb-6 break-inside-avoid rounded-2xl border border-sand bg-cream p-6 shadow-sm" data-id="element-205" data-mp="25pfpbukek2xk" data-mpi={i}>
              <QuoteIcon className="mb-3 h-6 w-6 text-sage/50" data-id="element-206" data-mp="1y5wk8owryr0m" />
              <p className="text-[15px] leading-relaxed text-ink/85" data-id="element-207" data-mp="228jj39rv5c7b">“{t.quote}”</p>
              <div className="mt-4 text-sm font-semibold text-sage-deep" data-id="element-208" data-mp="22ae22ijkqu8r">
                {t.name} · {t.location}
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}